'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const ValuePillars = () => {
    const pillars = [
        {
            title: 'Radical Transparency',
            description: 'No more guessing. We show you the dealership prices vs. independent shop rates side-by-side.',
            icon: 'EyeIcon',
            color: 'bg-primary/10 text-primary'
        },
        {
            title: 'Verified Expertise',
            description: 'Every mechanic on our platform is hand-verified and specializes in luxury automobile brands.',
            icon: 'ShieldCheckIcon',
            color: 'bg-success/10 text-success'
        },
        {
            title: 'Community Driven',
            description: 'Real reviews from your neighbors in your area help you make the best decision for your car.',
            icon: 'UserGroupIcon',
            color: 'bg-accent/10 text-accent'
        }
    ];

    return (
        <section className="py-24 bg-muted/30">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="font-heading text-3xl sm:text-4xl font-bold text-text-primary mb-4">
                        The Pillars of Our Platform
                    </h2>
                    <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto">
                        We built this service on three core principles to ensure you get the best possible care for your vehicle.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {pillars.map((pillar, idx) => (
                        <div
                            key={idx}
                            className="group bg-card p-10 rounded-2xl shadow-elevation-sm border border-border/50 transition-smooth hover:shadow-elevation-xl hover:-translate-y-2"
                        >
                            <div className={`w-16 h-16 rounded-2xl ${pillar.color} flex items-center justify-center mb-8 transition-smooth group-hover:scale-110`}>
                                <Icon name={pillar.icon} size={32} />
                            </div>
                            <h3 className="font-heading text-2xl font-bold text-text-primary mb-4 group-hover:text-primary transition-smooth">
                                {pillar.title}
                            </h3>
                            <p className="font-body text-text-secondary leading-relaxed">
                                {pillar.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ValuePillars;
